import { OrderbookListType } from 'components/OrderbookListType'
import { OrderbookPrecision } from 'components/OrderbookPrecision'
import { memo } from 'react'
import { useCurrentSpotSymbol } from 'store/spot/hooks'
import { List } from './List'
import {
  MobileTitle,
  OrderbookLabels,
  SelectOptionStyle,
  TitleWrap,
} from './style'
import { Stack } from '@mui/material'

export const SpotOrderbook = memo(() => {
  const {
    quoteScale = 0,
    baseCurrency = '',
    quoteCurrency = '',
  } = useCurrentSpotSymbol()

  return (
    <Stack flex={1}>
      <TitleWrap>Order Book</TitleWrap>
      <SelectOptionStyle>
        <OrderbookListType />
        <OrderbookPrecision quoteScale={quoteScale} />
      </SelectOptionStyle>
      <OrderbookLabels>
        <span>Price({quoteCurrency})</span>
        <span>Amount({baseCurrency})</span>
        <span>Total({quoteCurrency})</span>
      </OrderbookLabels>
      <MobileTitle>
        <span>Price</span>
        <span>Amount</span>
        <span>Price</span>
      </MobileTitle>
      <List />
    </Stack>
  )
})
